<template>
  <div id="list-room" class="right-content" v-if="isListingPage">
    <div class="main-content">
      <div class="content">
        <div class="tab-content py-0 px-0">
          <div>
            <v-row>
              <v-col class="text-right mr-5">
                <button class="btn btn-add-new mr-5" @click="addNew">{{ $t("ADD_NEW") }}</button>
                <button class="btn btn-copy" @click="copy">{{ $t("COPY") }}</button>
              </v-col>
            </v-row>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="dataTable"
              item-key="roomId"
              show-select
              disable-sort
              hide-default-footer
              :items-per-page="15"
              class="elevation-1 main-table"
            >
              <template slot="no-data">
                <span>{{$t("HAS_NO_DATA")}}</span>
              </template>
              <template v-slot:item.image="{ item }">
                <img
                  v-if="item.image"
                  :src="item.image"
                  width="137px"
                  style="height:76px; border-radius: 8px"
                />
                <img
                  v-else
                  src="@/assets/hotel/no-image.jpg"
                  width="137px"
                  style="height:76px; border-radius: 8px"
                />
              </template>
              <template v-slot:item.name="{ item }">
                <span
                  class="item-name"
                  v-if="item.i18ns.find(x => x.lang == systemLang)"
                >{{ item.i18ns.find(x => x.lang == systemLang).name }}</span>
              </template>
              <template v-slot:item.defaultPrice="{ item }">
                <span>{{ _formatCurrency(item.defaultPrice) }}</span>
              </template>
              <template v-slot:item.weekendRate="{ item }">
                <span>{{ _formatCurrency(item.weekendRate) }}</span>
              </template>
              <template v-slot:item.maxCustomers="{ item }">
                <span>{{ item.maxGuests }} {{ $t("GUEST") }}</span>,
                <br>
                <span>{{ item.maxAdults }} {{ $t("ADULT") }},</span>
                <br />
                <span>{{ item.maxChildern }} {{ $t("CHILDREN") }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <span class="edit" @click="editItem(item)">
                  {{
                  $t("EDIT")
                  }}
                </span>
                <span
                  class="delete"
                  @click="$refs.deleteDialogComponent.open(item)"
                >{{ $t("DELETE") }}</span>
              </template>
            </v-data-table>
            <paging v-if="paging.total" :paging.sync="paging" @changePage="changePage">
              <span slot="totalItems" v-if="paging">
                {{ $t("TOTAL") }}: {{ paging.total }}
                <span style="text-transform: lowercase">
                  {{
                  $t("ROOM_TYPE")
                  }}
                </span>
              </span>
            </paging>
          </div>
        </div>
        <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
          <v-card-title slot="title" class="headline p-0">{{ $t("CONFIRM_DELETE_ROOM") }}?</v-card-title>
        </delete-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import Paging from "@/components/Utils/Paging.vue";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";
export default {
  components: {
    "delete-dialog": DeleteDialog,
    paging: Paging
  },
  data() {
    return {
      systemLang: this.$i18n.locale,
      isListingPage: true,
      dialog: false,
      headers: [
        {
          text: this.$t("ROOM_IMAGE"),
          align: "center",
          value: "image",
          width: "14%"
        },
        {
          text: this.$t("ROOM_NAME"),
          align: "left",
          value: "name",
          width: "18%"
        },
        {
          text: this.$t("PRICE_NORMAL_DAY"),
          align: "left",
          value: "defaultPrice",
          width: "14%"
        },
        {
          text: this.$t("PRICE_WEEKEND"),
          align: "left",
          value: "weekendRate",
          width: "14%"
        },
        {
          text: this.$t("MAX_CUSTOMER_COUNT"),
          align: "left",
          value: "maxCustomers",
          width: "14%"
        },
        {
          text: this.$t("TOTAL_ROOM"),
          align: "left",
          value: "totalRooms",
          width: "14%"
        },
        {
          text: this.$t("ACTION"),
          align: "left",
          value: "action",
          width: "11%"
        }
      ],
      data: [],
      dataTable: [],
      selected: [],
      editedIndex: -1,
      editedItem: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      }
    };
  },
  created() {
    this.initialize();
  },
  watch: {},
  methods: {
    initialize() {
      service.getAllRooms().then(res => {
        this.data = res.data;
        this.dataTable = res.data;
        this.paging = {
          total: this.data.length,
          limit: 15,
          offset: 0
        };
      });
    },

    addNew() {
      this.$router.push({
        name: "roomDetail",
        params: { id: 0 }
      });
    },

    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        name: "roomDetail",
        params: { id: item.roomId }
      });
      localStorage.removeItem("RoomDetail");
    },

    deleteItem(item) {
      const index = this.data.indexOf(item);
      service.removeRoom(item.roomId).then(res => {
        if (res.responseCode == 0) {
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },

    redirect() {
      this.isListingPage = !this.isListingPage;
    },

    copy() {
      let listId = this.selected.map(x => x.roomId);
      service.duplicateRoom(listId).then(res => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          this.initialize();
          this.selected = [];
        }
      });
    },

    changePage(paging) {
      this.dataTable = this.data.slice(
        paging.offset,
        paging.offset + paging.limit
      );
    },
    _formatCurrency: _formatCurrency
  }
};
</script>